import { render } from "./SwitchTab.vue?vue&type=template&id=86d72ff8&scoped=true&ts=true"
import script from "./SwitchTab.vue?vue&type=script&lang=ts"
export * from "./SwitchTab.vue?vue&type=script&lang=ts"

import "./SwitchTab.vue?vue&type=style&index=0&id=86d72ff8&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86d72ff8"]])

export default __exports__